<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>
        <div v-if="!isCreate && !isLoading" class="employee-top-info">
            <ul class="select-photo-list">
                <li>
                    <a href="#">
                        <img
                            :src="employeeInfo.imageUrl === null ? '/img/temp/no_photo.jpg' : employeeInfo.imageUrl"
                            alt=""
                            @error="imageUrlAlt"
                        />
                        <span class="name">{{ staffTopInfo.name }}</span>
                        <span class="tel">{{ staffTopInfo.phone | phoneNumberFilter }}</span>
                        <span class="type">{{ staffTopInfo.roleName }}</span>
                        <span class="detail">{{ staffTopInfo.staffTeams }}</span>
                    </a>
                </li>
            </ul>
            <div class="btn-box" style="display: grid; width: max-content">
                <button v-if="isInService" class="com-btn gray" @click="onClickLeaveStaff">퇴사처리</button>
                <button v-else class="com-btn gray" @click="onClickEnterStaff">재입사</button>
                <button
                    v-show="isAllowed('ME', 6)"
                    class="com-btn white"
                    style="margin-top: 10px"
                    @click="showContractSendPopup()"
                >
                    계약서발송
                </button>
                <!-- <button class="com-btn gray" v-if="!isCreate" @click="onClickDeleteStaff">직원삭제</button> -->
            </div>
        </div>

        <div class="com-tab">
            <button :class="{ on: mode == 'info' }" type="button" @click="mode = 'info'">기본정보</button>
            <template v-if="$route.params.centerStaffId != undefined">
                <button :class="{ on: mode == 'salary' }" type="button" @click="mode = 'salary'">급여설정</button>
                <button :class="{ on: mode == 'time' }" type="button" @click="mode = 'time'">근무시간</button>
                <button :class="{ on: mode == 'contract' }" type="button" @click="mode = 'contract'">
                    계약서발송내역
                </button>
            </template>
        </div>

        <template v-if="mode == 'info'">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <template v-else>
                <div class="com-card-input half-type">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">사진</span>
                            <div class="input-cnt photo-line">
                                <span class="photo">
                                    <img :src="editField.imageUrl || defaultImageUrl" alt="사진" @error="imageUrlAlt" />
                                </span>
                                <div class="info-txt">
                                    <div>
                                        <b-form-file
                                            ref='imageFileInput'
                                            id="file1"
                                            accept=".jpg, .png, .gif"
                                            plain
                                            @change="handleImage"
                                            hidden
                                        />
                                        <label class="com-btn" for="file1">사진등록</label>
                                    </div>

                                    <button v-if='centerInfo.activeDoorCount' class="com-btn" @click="$modal.show('camera')">사진촬영</button>

                                    <button v-if='centerInfo.activeDoorCount' class="com-btn white" @click="deleteFace">사진삭제</button>
                                </div>
                            </div>

                            <div style='margin-top: 6px;'>
                                <span class="txt" style='font-size: 12px; color: #7e7777;'>※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                            </div>
                        </div>

                        <div class='line' v-if='centerInfo.totalDoorCount'>
                            <div style='display: flex; flex-direction: row; align-items: center; line-height: 32px;'>
                                <span class="tit">얼굴인식</span>

                                <span v-if='faceInProgress' class='app-txt' style='margin-left: 20px;'>처리중...</span>

                                <span  v-else :class="{'app-txt': true, 'blue': employeeInfo.doorRegStatus === 0}" style='margin-left: 20px;'>
                                    {{ employeeInfo.doorRegStatus === 0 ? '사용중' : !employeeInfo.doorRegStatus ? '미사용' : `미사용 (${DOOR_REG_ERR_MSG[employeeInfo.doorRegStatus]})` }}
                                </span>
                            </div>
                        </div>

                        <div class="line">
                            <div class="division">
                                <span class="tit">
                                    이름
                                    <span class="imp">*</span>
                                </span>
                                <div class="input-cnt">
                                    <input v-model="editField.name" class="w220" type="text" />
                                </div>
                            </div>
                            <div class="division">
                                <span class="tit">닉네임</span>
                                <div class="input-cnt">
                                    <input v-model="editField.nickName" class="w220" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                연락처
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <input
                                        v-model="editField.phone[0]"
                                        maxlength="3"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[1]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[2]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <btn-loading-spinner v-if="isProgressPhoneCheck"></btn-loading-spinner>
                                    <button
                                        v-else
                                        :disabled="isCheckedPhone"
                                        class="com-btn"
                                        @click="checkDuplicatePhone"
                                    >
                                        중복확인
                                    </button>
                                    <span id="isCheckedPhoneMsg" class="error red" v-html="isCheckedPhoneMsg"></span>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                직급/권한
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="['선택', ...roleTypeList]"
                                    :select-value="['', ...roleTypeValueList]"
                                    :selected-value="editField.roleId"
                                    class="w220"
                                    @update:set="(val) => (editField.roleId = val)"
                                ></select-form>
                            </div>
                            <span class="sub-info">※ 상세권한 수정은 직원설정 > 권한설정에서 가능합니다.</span>
                        </div>
                        <div class="line">
                            <span class="tit">팀</span>
                            <div class="input-cnt flex-wrap">
                                <select-form
                                    :select-data="['선택', ...teamTypeList]"
                                    :select-value="['', ...teamTypeValueList]"
                                    :selected-value="curSelectedTeam"
                                    class="w400"
                                    @update:set="
                                        (val) => (
                                            (curSelectedTeam = val),
                                            (curSelectedTeam2 = {
                                                centerTeamId: val,
                                                centerTeamName: teamTypeList[teamTypeValueList.indexOf(val)],
                                            })
                                        )
                                    "
                                ></select-form>
                                <button class="com-btn" @click="onClickAddTeam">추가</button>
                                <!-- 추가 일시 -->
                                <div
                                    v-for="(s, index) in editField.staffTeams"
                                    v-if="editField.staffTeams"
                                    :key="index"
                                    class="sub-line"
                                >
                                    <input v-model="s.centerTeamName" class="w400" type="text" />
                                    <button class="com-btn red" @click="onClickDeleteTeam(index)">삭제</button>
                                </div>
                                <!-- //추가 일시 -->
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">자격증 및 경력사항</span>
                            <div class="input-cnt">
                                <textarea
                                    :value="editField.memo"
                                    class="com-textarea w400"
                                    @input="onInputMemo"
                                ></textarea>
                                <br />
                                <span class="txt">
                                    {{ currentLetterNum | numberFormatFilter }}자 /
                                    {{ maxLetterNum | numberFormatFilter }}자
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">센터명</span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="[...chainCenterType]"
                                    :select-value="[...chainCenterTypeValue]"
                                    :selected-value="chainCenterId"
                                    class="w220"
                                    @update:set="(val) => (chainCenterId = val)"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                이메일
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-email">
                                    <input
                                        v-model="editField.email[0]"
                                        class="first"
                                        type="text"
                                    />
                                    <span class="txt">@</span>
                                    <input aria-hidden="true" class="last" style="display: none" type="text" />
                                    <input
                                        v-model="editField.email[1]"
                                        class="first"
                                        type="text"
                                    />
                                    <select-form
                                        v-if="isCreate"
                                        :select-data="['직접 입력', ...emailTypeList]"
                                        :select-value="['', ...emailTypeValueList]"
                                        @update:set="(val) => onChangeEmailSelect(val)"
                                    ></select-form>
                                </div>
                            </div>
                            <p class="notice-txt">
                                ※ 이메일 인증을 위해 실제 유효한 이메일을 사용해주세요.
                            </p>
                        </div>
                        <div class="line">
                            <span class="tit">
                                직원인증번호 (숫자 4자리)
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    v-model="editField.staffAuthNumber"
                                    class="w220"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <button class="com-btn" @click="generateStaffAuthNumber">자동생성</button>
                            </div>
                            <p class="notice-txt">
                                ※ ‘이메일’과 ‘직원인증번호’를 통해 로그인 전 ‘센터등록’ 후 핏투데이케어 사용을 시작할 수
                                있습니다.
                            </p>
                        </div>
                        <!-- <div class="line" v-if="isCreate">
                <span class="tit">비밀번호 <span class="imp">*</span></span>
                <div class="input-cnt">
                    <input type="password" class="w220" v-model="editField.password" />
                </div>
            </div>
            <div class="line" v-if="isCreate">
                <span class="tit">비밀번호 확인 <span class="imp">*</span></span>
                <div class="input-cnt">
                    <input type="password" class="w220" v-model="editField.rePassword" />
                </div>
            </div> -->
                        <div class="line">
                            <span class="tit">생년월일</span>
                            <div class="input-cnt">
                                <single-calendar
                                    :date="editField.birthday"
                                    class="w220"
                                    @update="onChangeBirthDay"
                                ></single-calendar>
                                <input
                                    maxlength="8"
                                    placeholder="직접입력(YYYYMMDD)"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeBirthDayTyping($event)"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">컬러선택</span>
                            <div class="input-cnt">
                                <div class="color-code">
                                    <button
                                        :style="{ backgroundColor: colorCodeData }"
                                        class="pop-btn"
                                        @click="colorPop = !colorPop"
                                    ></button>
                                    <!-- 클릭시 연동되는 배경칼라// -->
                                    <div v-show="colorPop" class="color-select">
                                        <div v-for="c in colorCodeArray" :key="c">
                                            <button
                                                :class="{ on: colorCodeData == c }"
                                                :disabled="teachersColor.includes(c) && editField.color !== c"
                                                :style="colorButtonIsDisabled(c, editField.color)"
                                                @click="
                                                    colorCodeData = c;
                                                    editField.color = c;
                                                    colorPop = false;
                                                "
                                            >
                                                {{ c }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                스케줄표 노출여부
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-1"
                                        v-model="editField.scheduleShowYn"
                                        :value="true"
                                        name="radio-s1"
                                        type="radio"
                                    />
                                    <label for="radio-s1-1">노출</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-2"
                                        v-model="editField.scheduleShowYn"
                                        :value="false"
                                        name="radio-s1"
                                        type="radio"
                                    />
                                    <label for="radio-s1-2">미노출</label>
                                </div>
                            </div>
                            <span class="sub-info">※ 일일스케줄/그룹주간표/강사주간표/룸스케줄에 노출합니다.</span>
                        </div>
                        <div class="line">
                            <span class="tit">
                                회원예약 노출여부
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-s2-1"
                                        v-model="editField.reserveShowYn"
                                        :value="true"
                                        name="radio-s2"
                                        type="radio"
                                    />
                                    <label for="radio-s2-1">노출</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s2-2"
                                        v-model="editField.reserveShowYn"
                                        :value="false"
                                        name="radio-s2"
                                        type="radio"
                                    />
                                    <label for="radio-s2-2">미노출</label>
                                </div>
                            </div>
                            <span class="sub-info">※ 회원예약 어플리케이션에 노출합니다.</span>
                        </div>
                        <div class="line">
                            <span class="tit">정보 노출여부</span>
                            <div class="input-cnt">
                                <div class="com-check">
                                    <input
                                        id="check-c1-1"
                                        v-model="editField.phoneShowYn"
                                        name="check-c1"
                                        type="checkbox"
                                    />
                                    <label for="check-c1-1">휴대전화</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-c1-2"
                                        v-model="editField.emailShowYn"
                                        name="check-c1"
                                        type="checkbox"
                                    />
                                    <label for="check-c1-2">이메일</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-c1-3"
                                        v-model="editField.certShowYn"
                                        name="check-c1"
                                        type="checkbox"
                                    />
                                    <label for="check-c1-3">자격증 및 경력사항</label>
                                </div>
                            </div>
                            <span class="sub-info">※ 체크 시, 회원예약 어플리케이션 '강사정보보기'에 노출됩니다.</span>
                        </div>
                        <div v-if="isInsteadOfAdmin" class="line">
                            <span class="tit">강사 제거</span>
                            <button class="com-btn" @click="onClickRemoveStaff">제거</button>
                        </div>
                        <div v-if="isInsteadOfAdmin" class="line">
                            <span class="tit">비밀번호 변경</span>
                            <button class="com-btn" @click="onClickReset">변경</button>
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickCancleBtn">취소</button>
                    <button v-if="isCreate" class="com-btn blue" @click="createCenterStaff">등록</button>
                    <button v-else class="com-btn blue" @click="updateCenterStaff">저장</button>
                </div>
            </template>
        </template>
        <employee-salary v-on:changeMode="changeMode()" v-else-if="mode == 'salary'"></employee-salary>
        <employee-time v-on:changeMode="changeMode()" v-else-if="mode == 'time'"></employee-time>
        <template v-else-if="mode == 'contract'">
            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">발송내역</span>
                    </div>
                    <div class="right-box">
                        <span class="txt">
                            총
                            <span class="blue">{{ contractSendListPagingInfo.totalItems }}</span>
                            개
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 245px" />
                        <col style="width: 285px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'cs_cre_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickSendDt"
                                >
                                    발송일시
                                </button>
                            </th>
                            <th>계약서명</th>
                            <th>발송인</th>
                            <th>서명기한</th>
                            <th>상태</th>
                            <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'cs_status_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickProcessDt"
                                >
                                    처리일시
                                </button>
                            </th>
                            <th>더보기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in contractSendList" :key="index">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.cst_id"
                                        v-model="selected"
                                        :value="index"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.cst_id"></label>
                                </div>
                            </td>
                            <td>{{ t.cs_cre_dt | timestampFilter2 }}</td>
                            <td>
                                <div style="width: 20vw">
                                    <div
                                        style="text-decoration: underline; cursor: pointer"
                                        @click="onShowContract(index)"
                                    >
                                        {{ t.ct_contract_title }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{ t.c_center_name }}
                            </td>
                            <td>
                                {{ t.cs_deadline_dt | timestampFilter2 }}
                            </td>
                            <td
                                :style="
                                    'color: ' +
                                    `${t.cs_status == 'R' ? '#00C7E5' : t.cs_status == 'C' ? '#f64444' : 'black'}`
                                "
                            >
                                {{ t.cs_status | getContractSendStatus }}
                            </td>
                            <td>
                                {{ t.cs_status_dt | timestampFilter2 }}
                            </td>
                            <td>
                                <el-dropdown class="view-more-dropdown" @command="onClickViewMore">
                                    <el-button type="primary" trigger="click">...</el-button>
                                    <el-dropdown-menu>
                                        <el-dropdown-item
                                            :command="`${it.type + '-' + index}`"
                                            v-for="it in selectViewMore"
                                            :key="it.type"
                                        >
                                            {{ it.name }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </td>
                        </tr>
                        <tr v-if="contractSendList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload()">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="contractSendListPagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="contractSendListPagingInfo.page"
                    :per-page="contractSendListPagingInfo.limit"
                    :total-rows="contractSendListPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        />

        <contract-preview-dlg
            v-if="contractPreviewPop"
            :show="contractPreviewPop"
            :templateSendId="selectedTemplateSendId"
            :close="handleCloseContractPreview"
        />

        <modal name="camera" :adaptive="true" :width="500" height="auto">
            <div class="container">
                <div slot="top-right">
                    <button class="close" @click="$modal.hide('camera')"></button>
                </div>

                <div class="title">사진촬영</div>

                <div style='display: flex; align-items: center; margin-bottom: 16px;'>
                    <web-cam
                        ref='webcam'
                        width='100%'
                        height='auto'
                        :selectFirstDevice='true'
                    />
                </div>

                <div style='display: flex; justify-content: space-between;'>
                    <span v-if='faceInProgress' class='app-txt'>처리중...</span>
                    <span v-else class="app-txt">
                        {{ employeeInfo.doorRegStatus ? DOOR_REG_ERR_MSG[employeeInfo.doorRegStatus] : '' }}
                    </span>

                    <button class="com-btn deep-blue" style='width: 160px; align-self: end;' @click="onTakePhoto">등록</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import moment from 'moment';
import { WebCam } from "vue-web-cam";
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateEmail, validateTelNo } from '@/assets/js/validation.js';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

import EmployeeSalary from './EmployeeSalary';
import EmployeeTime from './EmployeeTime';
import { Utils } from '@/assets/js/utils';
import ContractSendDlg from '../../../components/ContractSendDlg';
import ContractPreviewDlg from '../../../components/ContractPreviewDlg';
import { pagingInfo, convertImgToDataURLviaCanvas } from '@/assets/js/common';
import XLSX from 'xlsx';

import { EventBus } from '../../../main';

export default {
    name: 'SettingEmployeeInfo',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        EmployeeSalary,
        EmployeeTime,
        ContractSendDlg,
        ContractPreviewDlg,
        WebCam,
    },
    props: {},
    computed: {
        // 등록, 수정 페이지인지 구분 (true를 반환하면 등록, false를 반환하면 수정)
        isCreate() {
            return this.centerStaffId == null;
        },
        // 재직중인 직원여부 구분 (true를 반환하면 재직, false를 반환하면 퇴사)
        isInService() {
            return !this.isCreate && this.employeeInfo.status === 'I';
        },
        fullPhoneNumber() {
            const ed = this.editField;
            return `${ed.phone[0]}${ed.phone[1]}${ed.phone[2]}`;
        },
        fullEmail() {
            const ed = this.editField;
            return `${ed.email[0]}@${ed.email[1]}`;
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        isInsteadOfAdmin() {
            return this.$store.getters['auth/isInsteadOfAdmin'];
        },
    },
    created() {
        this.DOOR_REG_ERR_MSG = {
            11: '얼굴을 인식할수 없습니다',
            12: '얼굴 너비가 기준을 만족하지 않습니다.',
            13: '얼굴 높이가 기준을 만족하지 않습니다.',
            14: '얼굴이 뚜렷하지 않습니다.',
            15: '얼굴 밝기가 기준을 만족하지 않습니다.',
            16: '얼굴 대조도가 기준을 만족하지 않습니다.',
        }
    },
    mounted() {
        this.loginCenterId = parseInt(this.cId); // 로그인한 사용자의 centerId
        this.chainCenterId = parseInt(this.$store.getters['auth/cId']);
        this.init();
        this.invalidColorForTeacher();
        if (this.centerStaffId != null) {
            // 직원 수정시
            this.centerStaffId = parseInt(this.centerStaffId);
            this.isCheckedPhone = true; // 수정시에는 중복확인 되어 있는 상태
            this.fetchCenterStaffDetail();
        }
    },
    data() {
        return {
            loginCenterId: '',
            isLoading: false,
            mode: 'info',
            isProgressPhoneCheck: false,
            colorPop: false,
            colorCodeData: '', // 기본 설정 칼라

            isCheckedPhone: false, // 연락처 중복확인 여부
            isCheckedPhoneMsg: '', // 연락처 중복확인 메세지
            availablePhoneNumber: '', // 중복확인한 번호
            centerStaffId: this.$route.params.centerStaffId,
            employeeInfo: {},
            editField: {
                roleId: '',
                name: '',
                nickName: '',
                password: '',
                rePassword: '',
                memo: '',
                phone: ['', '', ''],
                email: ['', ''],
                birthday: '',
                sex: '', // 남성 : M, 여성 : W
                color: '',
                status: '', // 입사 : I, 퇴사 : O
                classType: '', // 대표 : P, 강사 : T, 매니저 : M, 상담원 : C, 기타직원 : N
                scheduleShowYn: true, // 스케줄표노출여부
                reserveShowYn: true, // 회원예약노출여부
                phoneShowYn: false, // 정보노출휴대전화
                emailShowYn: false, // 정보노출이메일
                certShowYn: false, // 정보노출자격증
                imageFile: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                imageUrl: '',
                staffTeams: [],
                staffAuthNumber: '',
            },
            emailTypeList: [...this.$emailType],
            emailTypeValueList: [...this.$emailType],
            defaultImageUrl: '/img/temp/no_photo.jpg',

            centerStaffRoleList: [], // api에서 받아오는 가공전 직급/권한 배열
            roleTypeList: [], // roleName List
            roleTypeValueList: [], // roleId List

            centerTeamList: [], // api에서 받아오는 가공전 팀 배열
            teamTypeList: [], // centerTeam name List
            teamTypeValueList: [], // centerTeamId List

            curSelectedRole: '', // 현재 선택되어 있는 직급/권한
            curSelectedTeam: '', // 현재 선택되어 있는 팀
            curSelectedTeam2: '', // 현재 선택되어 있는 팀

            chainCenterType: [], // 체인 센터명 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열
            chainCenterId: '',

            staffTopInfo: {
                // 상단에 노출되는 직원 정보 UI
                name: '',
                phone: '',
                roleName: '',
                staffTeams: '',
            },

            currentLetterNum: 0, // 자격증 및 경력사항 현재 글자수
            maxLetterNum: 20000, // 자격증 및 경력사항 최대 글자수
            teachersColor: [], // 선생들컬러
            colorCodeArray: [
                '#f44336',
                '#e91e63',
                '#9c27b0',
                '#673ab7',
                '#3f51b5',
                '#2196f3',
                '#03a9f4',
                '#00bcd4',
                '#009688',
                '#4caf50',
                '#8bc34a',
                '#cddc39',
                '#ffeb3b',
                '#ffc107',
                '#ff9800',
                '#ff5722',
                '#f472b6',
                '#8b5cf6',
                '#0099cc',
                '#1e40af',
                '#dc2626',
                '#854d0e',
                '#064e3b',
                '#3f6212',
                '#fca5a5',
                '#f87171',
                '#e94265',
                '#f6a66f',
                '#a7f3d0',
                '#2dd4bf',
                '#d9f99d',
                '#4ade80',
            ], // 컬러 코드 배열

            contractSendPop: false,
            contractSendList: [],
            contractSendListPagingInfo: { ...pagingInfo },
            contractSendListSortColumn: 'cs_cre_dt',
            contractSendListSortType: 'DESC',

            selectedAll: false,
            selected: [],

            selectViewMore: [
                { type: 1, name: '업데이트' },
                { type: 2, name: '다운로드' },
                { type: 3, name: '발송취소' },
                { type: 4, name: '기한연장' },
            ],
            contractSendInfo: {},
            centerInfo: {},
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            contractPreviewPop: false,
            selectedTemplateSendId: 0,

            cameraOn: false,
            faceInProgress: false,
        };
    },
    watch: {
        mode: {
            deep: true,
            handler() {
                if (this.mode == 'contract') {
                    this.fetchContractSendList();
                }
            },
        },
    },
    methods: {
        async init() {
            await this.getCenterInfo();
            await this.fetchCenterStaffRole(); // 직급 권한 목록 가져오기
            await this.fetchCenterTeam(); // 팀 목록 가져오기
            await this.fetchChainCenter(); // 체인 센터명 목록 가져오기
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.contractSendList) {
                    this.selected.push(i);
                }
            }
        },

        onShowContract(index) {
            this.selectedTemplateSendId = this.contractSendList[index].cst_id;

            this.contractPreviewPop = true;
        },

        handleCloseContractPreview() {
            this.contractPreviewPop = false;
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.contractSendListPagingInfo.page = event;
            this.fetchContractSendList();
        },

        async fetchContractSendList() {
            try {
                this.isLoading = true;

                const { data } = await this.sendGetContractSendList();
                this.setPageParams(data);
                this.contractSendList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        sendGetContractSendList() {
            const params = {
                sortColumn: this.contractSendListSortColumn,
                sortType: this.contractSendListSortType,
                ...this.contractSendListPagingInfo,
            };

            return api.get(`/admin/api/center/contract/list/recipient/${this.centerStaffId}/1`, {
                params,
            });
        },
        // Paging Param 설정
        setPageParams(data) {
            this.contractSendListPagingInfo.totalPages = data.meta.totalPages;
            this.contractSendListPagingInfo.page = data.meta.currentPage;
            this.contractSendListPagingInfo.totalItems = data.meta.totalItems;
            this.contractSendListPagingInfo.itemCount = data.meta.itemCount;
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.sendGetContractSendList();

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['발송일시'] = this.$options.filters.timestampFilter2(item.cs_cre_dt);
                temp['계약서명'] = item.ct_contract_title;
                temp['발송인'] = item.c_center_name;
                temp['서명기한'] = this.$options.filters.timestampFilter2(item.cs_deadline_dt);
                temp['상태'] = this.$options.filters.getContractSendStatus(item.cs_status);
                temp['처리일시'] = this.$options.filters.timestampFilter2(item.cs_status_dt);

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '계약서발송내역');
            XLSX.writeFile(wb, `계약서발송내역_${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.contractSendListPagingInfo.limit = val;
            this.fetchContractSendList();
        },

        changeMode() {
            this.mode = 'info';

            this.mode = 'salary';
        },

        // 센터 직급/권한 목록 가져오기
        async fetchCenterStaffRole() {
            try {
                let { centerStaffRoleList, roleTypeList, roleTypeValueList } = this;

                const { data } = await this.sendGetCenterStaffRole();

                centerStaffRoleList = data;
                centerStaffRoleList.forEach((role) => {
                    roleTypeList.push(role.roleName);
                    roleTypeValueList.push(String(role.roleId));
                });
            } catch (error) {
                alert('직급/권한을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 직급권한 목록 조회 API
        sendGetCenterStaffRole() {
            return api.get(`/admin/api/centerStaffRole/${this.loginCenterId}/all`);
        },

        // 센터팀 목록 가져오기
        async fetchCenterTeam() {
            try {
                let { centerTeamList, teamTypeList, teamTypeValueList } = this;

                const { data } = await this.sendGetCenterTeam();

                centerTeamList = data;
                centerTeamList.forEach((team) => {
                    teamTypeList.push(team.name);
                    teamTypeValueList.push(String(team.centerTeamId));
                });
            } catch (error) {
                alert('센터팀 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.loginCenterId}`);
        },

        // 센터팀 목록 조회 API
        sendGetCenterTeam() {
            return api.get(`/admin/api/center/${this.loginCenterId}/team`);
        },

        // 이메일 select 변경시
        onChangeEmailSelect(val) {
            const temp = [this.editField.email[0], val];
            this.editField.email = temp;
        },
        // 센터 직원 상세 조회 API
        sendGetCenterStaffDetail(centerStaffId) {
            return api.get(`/admin/api/center/${this.loginCenterId}/staff/${centerStaffId}`);
        },

        // 직원 정보 fetch
        async fetchCenterStaffDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetCenterStaffDetail(this.centerStaffId);

                this.employeeInfo = { ...data };

                const { editField, employeeInfo, staffTopInfo } = this;

                // let { name, nickName, memo, birthday, color, scheduleShowYn, reserveShowYn, phoneShowYn, emailShowYn, certShowYn, phone} = this.editField;
                this.colorCodeData = await data.color;
                this.curSelectedRole = String(employeeInfo.roleId);

                // 상단에 노출되는 직원 카드
                staffTopInfo.name = employeeInfo.name;
                staffTopInfo.phone = employeeInfo.phone;

                if (employeeInfo.centerStaffRole) {
                    staffTopInfo.roleName = employeeInfo.centerStaffRole.roleName;
                } else {
                    staffTopInfo.roleName = '-';
                }

                if (employeeInfo.centerStaffTeams.length == 1) {
                    staffTopInfo.staffTeams = employeeInfo.centerStaffTeams[0].centerTeam.name;
                } else if (employeeInfo.centerStaffTeams.length == 0) {
                    staffTopInfo.staffTeams = '-';
                } else {
                    staffTopInfo.staffTeams = `${employeeInfo.centerStaffTeams[0].centerTeam.name} 외 ${
                        employeeInfo.centerStaffTeams.length - 1
                    }`;
                }

                if (employeeInfo.centerStaffTeams.length > 0) {
                    employeeInfo.centerStaffTeams.forEach((s) => {
                        const temp = {
                            centerTeamId: s.centerTeam.centerTeamId,
                            centerTeamName: s.centerTeam.name,
                        };
                        editField.staffTeams.push(temp);
                    });
                }

                editField.roleId = String(employeeInfo.roleId);
                editField.name = employeeInfo.name;
                editField.nickName = employeeInfo.nickName;
                editField.memo = employeeInfo.memo;
                editField.birthday = employeeInfo.birthday;
                editField.color = employeeInfo.color;
                editField.scheduleShowYn = employeeInfo.scheduleShowYn;
                editField.reserveShowYn = employeeInfo.reserveShowYn;
                editField.phoneShowYn = employeeInfo.phoneShowYn;
                editField.emailShowYn = employeeInfo.emailShowYn;
                editField.certShowYn = employeeInfo.certShowYn;
                editField.classType = employeeInfo.classType;
                editField.birthday = this.splitBirthday(employeeInfo.birthday);
                editField.phone = this.splitPhoneNumber(employeeInfo.phone);
                editField.email = this.splitEmail(employeeInfo.email);
                editField.staffAuthNumber = employeeInfo.staffAuthNumber;
                editField.imageUrl = employeeInfo.imageUrl;

                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 생년월일 format '-'으로 변경
        splitBirthday(birthday) {
            if (birthday.length === 8) {
                return birthday.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
            }
        },

        // 생년월일 변경 이벤트
        onChangeBirthDay(val) {
            this.editField.birthday = val;
        },

        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.editField.imageFile.filename = selectedImage.name;
            this.editField.imageFile.mimetype = selectedImage.type;
            this.createBase64Image(selectedImage);

            this.$refs.imageFileInput.reset();
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.registerFace(e.target.result)

                this.editField.imageUrl = e.target.result;
                this.editField.imageFile.base64data = this.editField.imageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        // 휴대폰 번호가 숫자인지 확인
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 연락처 변경 이벤트
        onChangePhoneNumber() {
            const { fullPhoneNumber } = this;

            switch (fullPhoneNumber) {
                case '':
                case this.employeeInfo.phone:
                case this.availablePhoneNumber:
                    this.isCheckedPhone = true;
                    break;
                default:
                    this.isCheckedPhone = false;
                    break;
            }
        },

        // 연락처 중복확인
        async checkDuplicatePhone() {
            // 이미 체크한 경우
            if (this.isCheckedPhone) {
                return;
            }

            const {
                phone: [phoneFirst, phoneSecond, phoneThird],
            } = this.editField;

            // 전화번호
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                alert('연락처를 입력하세요.');
                return false;
            }

            this.isProgressPhoneCheck = true;
            const { data } = await api.get(
                `/admin/api/center/${this.loginCenterId}/staff/phoneNumberDeplexCheck/${this.fullPhoneNumber}`
            );

            const msg = document.querySelector('#isCheckedPhoneMsg');

            if (data.phoneNumberCount === 0) {
                this.isCheckedPhone = true;
                this.isCheckedPhoneMsg = '사용 가능합니다.';
                this.availablePhoneNumber = this.fullPhoneNumber;
                msg.className = 'error green';
            } else {
                this.isCheckedPhone = false;
                this.isCheckedPhoneMsg = '사용중인 번호입니다.';
                this.availablePhoneNumber = '';
                msg.className = 'error red';
            }
            this.isProgressPhoneCheck = false;
        },

        // validate
        validateValues() {
            // 필수값 체크
            let result = false;
            const {
                name,
                nickName,
                phone: [phoneFirst, phoneSecond, phoneThird],
                email: [emailFirst, emailSecond],
                roleId,
                color,
            } = this.editField;
            let msg = '';

            // 이름
            if (name.trim() === '') {
                msg = '이름을 입력하세요.';
                return { result, msg };
            } else if (name.length === 1) {
                msg = '이름을 다시 입력하세요.';
                return { result, msg };
            }

            // // 닉네임
            // if (!nickName || nickName.length === 0) {
            //     msg = '닉네임을 입력해주세요.';
            //     return { result, msg };
            // }

            // if (nickName.length === 1) {
            //     msg = '닉네임을 다시 입력하세요.';
            //     return { result, msg };
            // }

            // 전화번호
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                msg = '연락처를 입력하세요.';
                return { result, msg };
            } else if (
                !validateTelNo(this.fullPhoneNumber) ||
                phoneFirst.length < 2 ||
                phoneSecond.length < 3 ||
                phoneThird.length != 4
            ) {
                msg = '연락처를 다시 확인하세요.';
                return { result, msg };
            }

            if (!this.isCheckedPhone) {
                msg = '연락처 중복확인을 해주세요.';
                return { result, msg };
            }

            // 직급/권한
            if (roleId === '') {
                msg = '직급/권한을 선택하세요.';
                return { result, msg };
            }

            // 이메일
            if (emailFirst.trim() === '' || emailSecond.trim() === '') {
                msg = '이메일을 입력하세요.';
                return { result, msg };
            } else if (!validateEmail(this.fullEmail)) {
                msg = '이메일을 다시 확인하세요.';
                return { result, msg };
            }

            // 비밀번호
            const { password, rePassword, staffAuthNumber } = this.editField;

            // 신규 등록일 때에만 필수입력
            if (this.isCreate) {
                /*
        if (password.trim() === '' || rePassword.trim() === '') {
            msg = '비밀번호를 입력하세요.';
            return { result, msg };
        }
         */
                if (staffAuthNumber.trim().length < 4) {
                    msg = '직원인증번호를 4자리 숫자로 입력해주세요';
                    return { result, msg };
                }
            }

            if (password.trim() !== '' && password !== rePassword) {
                msg = '비밀번호를 다시 확인하세요.';
                return { result, msg };
            }

            if ((password.length > 0 && password.length < 8) || (rePassword.length > 0 && rePassword.length < 8)) {
                msg = '비밀번호를 8자리 이상 입력하세요.';
                return { result, msg };
            }

            if (this.colorButtonTrueOrFalse(color)) {
                msg = '선택한 색상은 다른직원이 사용하고 있습니다.';
            }

            result = true;
            return { result };
        },

        // 직원 등록 API 호출
        sendPostStaff(centerId, centerStaffData) {
            return api.post(`/admin/api/center/${centerId}/staff`, {
                ...centerStaffData,
            });
        },

        // 직원 신규 등록
        async createCenterStaff() {
            const validate = this.validateValues();

            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            if (!confirm('직원등록을 하시겠습니까?')) {
                return false;
            }

            const params = this.getCreateParams();

            try {
                this.isLoading = true;
                let centerId;
                this.chainCenterId === '' ? (centerId = this.loginCenterId) : (centerId = this.chainCenterId);

                const { data } = await this.sendPostStaff(centerId, params);

                alert('직원이 등록 되었습니다.');
                this.isLoading = false;

                this.$router.push({ name: 'SettingEmployeeList' });
            } catch (error) {
                this.isLoading = false;

                Utils.alertResponseErrorMessge(error);
            }
        },

        // 직원 등록시 파라미터 가공
        getCreateParams() {
            let {
                name,
                nickName,
                password,
                rePassword,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
                roleId,
                staffAuthNumber,
            } = this.editField;
            const phone = this.fullPhoneNumber;
            const email = this.fullEmail;
            const color = this.colorCodeData;
            const birthday = this.editField.birthday.replace(/-/g, '');
            // 현재 UI에 입력값 없음
            const sex = 'M';
            const classType = 'T'; // 대표 = "P", 강사 = "T", 매니저 = "M", 상담원 = "C", 기타직원 = "N"   확인 후 수정 예정
            if (this.curSelectedTeam2.centerTeamId) {
                staffTeams.push(this.curSelectedTeam2);
            }
            staffTeams = staffTeams.filter(
                (a, b) => staffTeams.findIndex((c, d) => a.centerTeamId === c.centerTeamId) === b
            );
            return {
                roleId,
                name,
                nickName,
                birthday,
                sex,
                phone,
                classType,
                email,
                password,
                rePassword,
                color,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
                staffAuthNumber,
            };
        },

        // 이메일 주소 Split
        splitEmail(email) {
            if (!email) return email;

            const tmp = ['', ''];
            tmp[0] = email.split('@')[0];
            tmp[1] = email.split('@')[1];
            return tmp;
        },

        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },

        async updateRoleAuthority() {
            this.$store.state.auth.user.roleId = this.editField.roleId;

            const eventCds = (await this.allowedMenuEvent.getEventCd()).data;
            localStorage.setItem('menuEventCds', JSON.stringify(eventCds));

            let showElectronicContract = false;
            for (const cd of eventCds) {
                if (cd === 'ME_EVENT_005') {
                    showElectronicContract = true;
                }
            }

            EventBus.$emit('refresh_menu2', { showElectronicContract });
        },

        // 직원 저장(수정) 버튼 클릭시
        async updateCenterStaff() {
            const validate = this.validateValues();

            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            if (!confirm('수정 하시겠습니까?')) {
                return false;
            }

            const params = this.getUpdateParams();

            try {
                this.isLoading = true;
                const { data } = await this.sendPutStaff(this.loginCenterId, params);

                this.updateRoleAuthority();

                alert('직원이 수정 되었습니다.');
                this.isLoading = false;
                this.$router.push({ name: 'SettingEmployeeList' });
            } catch (error) {
                alert(error.response.data.error);
                this.isLoading = false;
                console.log('===> Failed Staff Update : ', error);
            }
        },

        sendPutStaff(centerId, params) {
            return api.put(`/admin/api/center/${centerId}/staff/${this.centerStaffId}`, {
                ...params,
            });
        },

        // 직원 수정시 파라미터 가공
        getUpdateParams() {
            let {
                name,
                nickName,
                password,
                rePassword,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
                roleId,
                staffAuthNumber,
            } = this.editField;
            const phone = this.fullPhoneNumber;
            const email = this.fullEmail;
            const color = this.colorCodeData;
            const birthday = this.editField.birthday.replace(/-/g, '');
            // 현재 UI에 입력값 없음
            const sex = 'M';
            const classType = 'T'; // 대표 = "P", 강사 = "T", 매니저 = "M", 상담원 = "C", 기타직원 = "N"   확인 후 수정 예정
            if (this.curSelectedTeam2.centerTeamId) {
                staffTeams.push(this.curSelectedTeam2);
            }
            staffTeams = staffTeams.filter(
                (a, b) => staffTeams.findIndex((c, d) => a.centerTeamId === c.centerTeamId) === b
            );
            const params = {
                roleId,
                name,
                nickName,
                birthday,
                sex,
                phone,
                classType,
                email,
                password,
                rePassword,
                color,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
                staffAuthNumber, // 수정시 값 등록
            };
            if (imageFile.filename === '') {
                // 사진을 수정하지 않았으면 imageFile은 삭제
                delete params.imageFile;
            }
            return params;
        },

        // 취소 버튼 클릭시 센터 직원 목록으로 이동
        onClickCancleBtn() {
            this.$router.push({ name: 'SettingEmployeeList' });
        },
        async onClickRemoveStaff() {
            if (window.confirm('강사를 제거하시겠습니까?')) {
                await api.delete(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/`);
                window.alert('제거가 완료되었습니다.');
                this.$router.push({ name: 'SettingEmployeeList' });
            }
        },

        async onClickReset() {
            if (window.confirm('강사를 비밀번호를 초기화하시겠습니까?')) {
                await api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pw`);
                window.alert('초기화가 완료되었습니다.');
                this.$router.push({ name: 'SettingEmployeeList' });
            }
        },

        // 팀 추가 버튼 클릭시
        onClickAddTeam() {
            if (this.curSelectedTeam === '') {
                alert('팀을 선택하세요.');
                return;
            }

            // 이미 추가되어 있는 팀인지 찾기
            let duplicateTeam = false;
            this.editField.staffTeams.forEach((team) => {
                if (String(team.centerTeamId) === String(this.curSelectedTeam)) {
                    duplicateTeam = true;
                }
            });
            if (duplicateTeam) {
                // true이면 이미 추가되어 있는 팀
                alert('이미 추가된 팀입니다.');
                this.curSelectedTeam = '';
                return;
            }

            const { teamTypeList, editField } = this;
            const index = this.teamTypeValueList.findIndex((value) => value === this.curSelectedTeam);
            const teamName = teamTypeList[index];

            const tempObj = {
                centerTeamId: this.curSelectedTeam,
                centerTeamName: teamName,
            };
            editField.staffTeams.push(tempObj);

            this.curSelectedTeam = '';
        },

        // 팀 삭제 버튼 클릭시
        onClickDeleteTeam(index) {
            const { staffTeams } = this.editField;
            staffTeams.splice(index, 1);
        },

        // 퇴사처리 버튼 클릭시
        async onClickLeaveStaff() {
            try {
                if (!confirm(`${this.employeeInfo.name}을 정말 퇴사처리 하시겠습니까?`)) {
                    return false;
                }
                const lessons = await api.get(
                    `/admin/api/center/${this.loginCenterId}/lesson/schedule/teacher/schedule/leave?centerStaffId=${this.centerStaffId}`
                );
                if (parseInt(lessons.data.count, 10) > 0) {
                    if (!confirm(`미래의 일자에 수업 예약이 있습니다 퇴사 처리 시 해당 수업은 취소 됩니다`)) {
                        return false;
                    }
                }
                const { data } = await this.sendPutLeaveStaff();
                alert('퇴사처리 되었습니다.');
                this.$router.push({ name: 'SettingEmployeeList' });
            } catch (error) {
                alert('퇴사처리 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원삭제 버튼 클릭시
        async onClickDeleteStaff() {
            try {
                if (!confirm(`${this.employeeInfo.name}을 정말 삭제하시겠습니까? 삭제 후 복구는 불가합니다.`)) {
                    return false;
                }
                const { data } = await this.sendDeleteStaff();
                alert('직원이 삭제 되었습니다.');
                this.$router.push({ name: 'SettingEmployeeList' });
            } catch (error) {
                alert('직원삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 재입사 버튼 클릭시
        async onClickEnterStaff() {
            try {
                if (!confirm(`${this.employeeInfo.name}을 재입사처리 하시겠습니까?`)) {
                    return false;
                }
                const { data } = await this.sendPutEnterStaff();
                alert('재입사처리 되었습니다.');
                this.$router.push({ name: 'SettingEmployeeList' });
            } catch (error) {
                alert('재입사처리 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 퇴사처리 API 호출
        sendPutLeaveStaff() {
            return api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/leave`);
        },

        // 직원삭제 API 호출
        sendDeleteStaff() {
            return api.delete(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}`);
        },

        // 직원재입사 API 호출
        sendPutEnterStaff() {
            return api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/enter`);
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            let centerId;
            this.chainCenterId === '' ? (centerId = this.loginCenterId) : (centerId = this.chainCenterId);
            return api.get(`/admin/api/center/${centerId}/chain`);
        },

        // 생년월일 직접 입력시
        onChangeBirthDayTyping(e) {
            if (e.target.value.length < 8) {
                return;
            }
            this.editField.birthday = moment(e.target.value).format('YYYY-MM-DD');
            e.target.value = '';
        },

        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },
        generateStaffAuthNumber() {
            this.editField.staffAuthNumber = Utils.getRandomNumber(4);
        },
        onInputMemo(event) {
            if (event.target.value.length <= this.maxLetterNum) {
                this.editField.memo = event.target.value;
                this.currentLetterNum = event.target.value.length;
            } else {
                event.target.value = this.editField.memo;
                alert(`${Utils.getNumberFormat(this.maxLetterNum)}자 이하까지 작성 가능합니다`);
            }
        },
        async invalidColorForTeacher() {
            try {
                const colors = await this.getTeachersInfo();
                for (const color of colors) {
                    if (this.colorCodeData === color) {
                    } else {
                        this.teachersColor.push(color.color);
                    }
                }
                this.getInitColor(this.colorCodeArray);
            } catch (error) {
                console.log('noColor..');
            }
        },
        getTeachersInfo() {
            return api
                .get(`/admin/api/center/${this.cId}/staff/teachers/list`)
                .then((response) => response.data)
                .catch((error) => {});
        },
        colorButtonTrueOrFalse(colorCode) {
            let answer = false;
            answer = this.teachersColor.includes(colorCode);
            return answer;
        },
        colorButtonIsDisabled(colorCode, filledColor) {
            const answer = {};

            if (this.colorButtonTrueOrFalse(colorCode)) {
                answer.backgroundColor = colorCode;
                if (filledColor !== colorCode) {
                    answer.opacity = '0.8';
                    answer.background = `repeating-linear-gradient(
                        135deg, ${colorCode}, ${colorCode} 5px, #ffffff 5px, #ffffff 7px
                    )`;
                }
            } else {
                answer.backgroundColor = colorCode;
            }
            return answer;
        },
        getInitColor(colorCodes) {
            for (const colorCode of colorCodes) {
                let answer = 0;
                let color = '';
                for (color of this.teachersColor) {
                    if (colorCode === color) {
                        answer++;
                    }
                }
                if (!answer) {
                    this.colorCodeData = colorCode;
                    return;
                }
            }
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.loginCenterId,
                centerName: this.centerInfo.centerName,
                customerId: this.centerStaffId,
                customerName: this.employeeInfo.name,
                customerPhone: this.employeeInfo.phone,
                templateType: 'P',
            };

            this.contractSendPop = true;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.mode = 'contract';
            this.fetchContractSendList();
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.contractSendListSortColumn = 'cs_cre_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }
            this.fetchContractSendList();
        },

        // 유효기간 컬럼 클릭시
        onClickProcessDt() {
            this.contractSendListSortColumn = 'cs_status_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }
            this.fetchContractSendList();
        },

        getTemplate(templateSendId) {
            return api.get(
                `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/contract/template/send/${templateSendId}`
            );
        },

        getElementItemHtml(item, senderImageRawData, recipientImageRawData) {
            let html = ``;
            const index = 0;

            html += `
              <div class='contract-content-info'>
                    <div class='contract-title-input' style='margin-bottom: 20px; background-color: white'>
                        ${item.e_contract_title}
                    </div>
                    <div class='contract-info-title'>수신인 정보</div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>이름</div>
                        <div class='contract-info-sub-title'>${item.recipientName}</div>
                    </div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>연락처</div>
                        <div class='contract-info-sub-title'>${item.recipientPhone}</div>
                    </div>`;
            if (item.e_contract_member_type == 'M' && item.centerContractId > 0 && item.centerProdId > 0) {
                const ticketInfo = JSON.parse(item.ticketInfo);
                if (ticketInfo && ticketInfo.length > 0) {
                    html += `<div class='contract-info-title'>이용권 정보</div>`;

                    ticketInfo.map((t) => {
                        html += `
                            <div class='ticket-container'>
                                <div class='ticket-box'>
                                    <div class='ticket-box-title'>${t.title}</div>
                                    <div class='ticket-box-info'>
                                        <div style='flex: 1'>
                                            ${t.period}
                                        </div>
                                        <div>
                                            ${t.price}원
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    });
                }
            }
            html += `<div class='contract-info-title'>약관</div>`;

            if (item.templateInfo) {
                item.templateInfo.map((it, i) => {
                    html += `<div style='padding: 10px 10px 0 10px'>`;

                    const content = it.content.replace(new RegExp('\n', 'g'), '<br>');

                    if (it.type == 1) {
                        html += `
                        <div>
                            <div class='contract-info-sub-title' style='display: flex'>
                                <div style='flex: 1;'>${it.title}</div>
                            </div>
                            <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>
                        </div>
                      `;
                    } else {
                        html += `
                        <div style='display: flex'>
                            <div style='flex: 1;'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1;'>${it.title}</div>
                                </div>
                                <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>`;

                        it.options.map((jt, j) => {
                            html += `
                            <div style='display: flex; align-items: center; margin-top: 10px'>
                                <div class='com-check'>
                                    <input
                                        :id='agree-check-${index}-${i}-${j}'
                                        name='check-c1'
                                        ${jt.checked ? 'checked' : ''}
                                        type='checkbox'
                                        disabled
                                    />
                                    <label :for='agree-check-${index}-${i}-${j}' class='agree-option'></label>
                                </div>
                                <div class='agree-option-input'>${jt.title}</div>
                            </div>
                          `;
                        });

                        html += `
                            </div>
                        </div>`;
                    }

                    html += `</div>`;
                });
            }

            html += `
                    <div style='display: flex'>
                        <div class='contract-info-title' style='flex: 1;'>${this.$options.filters.dateFormatFilter2(
                            item.sendTime
                        )}</div>
                        <div style='width: 300px; margin-top: 40px;'>
                            <div style='display: flex; align-items: center'>
                                <div class='contract-info-person'>수신인</div>
                                <img class='contract-info-signature' src='${recipientImageRawData}' />
                            </div>
                            <div style='display: flex; align-items: center; margin-top: 10px;'>
                                <div class='contract-info-person'>발신인</div>
                                <img class='contract-info-signature' src='${senderImageRawData}' />
                            </div>
                        </div>
                    </div>
                  </div>
              `;

            return html;
        },

        getElementHtml(list, callback) {
            const item = list[0];
            let senderImageRawData = item.senderSignImageUrl;
            let recipientImageRawData = item.recipientSignImageUrl;
            // const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);
            // callback(html);

            convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                senderImageRawData = imageRawData;

                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                    recipientImageRawData = imageRawData;

                    const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);

                    callback(html);
                });
            });
        },

        getPDFContent(index, returnBuffer = false) {
            return Promise.all([this.getTemplate(this.contractSendList[index].cst_id)]).then((response) => {
                if (response && response.length > 0) {
                    const list = response[0].data;

                    const element = document.createElement('div');
                    element.style.padding = '20px';

                    this.getElementHtml(list, (html) => {
                        element.innerHTML = html;
                        let filename = `${this.contractSendList[index].ct_contract_title}.pdf`;
                        if (this.contractSendList[index].recipient_name) {
                            filename = `${this.contractSendList[index].ct_contract_title}(${this.contractSendList[index].recipient_name}).pdf`;
                        }

                        const opt = {
                            filename,
                            enableLinks: true,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: {
                                scale: 3,
                                y: -40,
                                scrollY: 0,
                                useCORS: true,
                                width: 800,
                                height: 1130,
                                letterRendering: true,
                            },
                            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                        };

                        if (returnBuffer) {
                            return html2pdf().from(element).set(opt).output();
                        }
                        return html2pdf().from(element).set(opt).save();
                    });
                }
            });
        },

        async onClickViewMore(command) {
            const data = command.split('-');
            const index = data[1];
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'P') {
                alert('기간만료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'R') {
                alert('이미 완료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'N') {
                alert('이미 거절된 계약서입니다.');
                return;
            }

            if (data[0] == 1) {
                this.fetchContractSendList();
            } else if (data[0] == 2) {
                this.getPDFContent(index);
            } else if (data[0] == 3) {
                if (this.contractSendList[index].cs_status == 'S') {
                    if (confirm('계약서 발송을 취소 하시겠습니까?')) {
                        const data = await api.put(
                            `/admin/api/center/contract/send/cancel/${this.contractSendList[index].cst_id}`
                        );
                        if (data) {
                            alert('취소 요청이 접수되었습니다.');
                            this.fetchContractSendList();
                        }
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 완료된 계약서입니다.');
                }
            } else if (data[0] == 4) {
                const index = data[1];
                if (this.contractSendList[index].cs_status == 'S') {
                    if (
                        confirm(
                            '서명기한을 연장할 경우 연장된 기한으로 해당 계약서가 자동으로 재전송됩니다. 진행하시겠습니까?'
                        )
                    ) {
                        const data = await api.put(
                            `/admin/api/center/contract/expand/deadline/${this.contractSendList[index].cst_id}/1`
                        );
                        if (data) {
                            alert('계약서가 연장된 기한으로 재발송되었습니다.');
                            this.fetchContractSendList();
                        }
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 발송된 계약서입니다.');
                }
            }
        },

        async onTakePhoto() {
            const imageData = this.$refs.webcam.capture();
            await this.registerFace(imageData);
        },

        async registerFace(imageData) {
            if (!this.centerInfo.activeDoorCount || !imageData) return;

            this.faceInProgress = true;

            try {
                const url = `/admin/api/center/${this.loginCenterId}/door/face/${this.centerStaffId}`
                await api.post(url, { face_template: imageData, staff: true });

                setTimeout(async () => {
                    const { data } = await this.sendGetCenterStaffDetail(this.centerStaffId);
                    this.employeeInfo = { ...data };
                    this.editField.imageUrl = data.imageUrl;

                    this.faceInProgress = false;
                    if (this.employeeInfo.doorRegStatus === 0) {
                        this.$modal.hide('camera')
                    }
                }, 3000);
            } catch (e) {
                this.faceInProgress = false;
                this.employeeInfo.doorRegStatus = null;
            }
        },

        async deleteFace() {
            if (this.employeeInfo.imageUrl == null) return;

            this.faceInProgress = true;

            try {
                const url = `/admin/api/center/${this.loginCenterId}/door/face/${this.centerStaffId}`
                await api.delete(url, {
                    data: { staff: true }
                });

                setTimeout(async () => {
                    const { data } = await this.sendGetCenterStaffDetail(this.centerStaffId);
                    this.employeeInfo = { ...data };
                    this.editField.imageUrl = data.imageUrl;

                    this.faceInProgress = false;
                }, 3000);
            } catch (e) {
                this.faceInProgress = false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.vm--modal {
    .container {
        display: flex;
        flex-direction: column;
        padding: 16px;
    }

    .title {
        padding-bottom: 10px;
        text-align: center;
        font-size: 20px;
        color: #0078f4;
    }

    .close {
        float: right;
        width: 20px;
        height: 20px;
        background: url(/img/icons/layerpop_square_close_btn.jpg) no-repeat 0 0;
        border: none;
    }

    .center {
        display: block;
        width: 100%;
        height: 56px;
        margin-top: 16px;
        border-radius: 0;
        border: 1px solid #e1e1e1;
        background: #f1f5f7;
        font-size: 16px;
        text-align: center;
        color: #7e7777;
    }
}
</style>
